import React from 'react'

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

var tracery = require('tracery-grammar');


const grammarEN = {
    "WORK":["an artwork", "a poem", "a song", "a text", "a theatre play", "a generative artwork", "a painting", "a symphony", "a thought", "a breeze of air", "a piece of pottery", "a haiku", "a sculpture", "an encrypted file", "a telephone call", "a walk in the forest"],
    "NOUN3":["paper", "stone", "milk", "water", "air", "fur", "faces", "choirs", "musicians"],
    "NOUN2":["winds", "rainshowers", "sunbeams", "wastelands", "conspiracies", "asteroids", "arteries", "channels", "roads", "power lines", "eggs"],
    "VERB1":["consisting only of", "containing many", "written by", "composed by", "made out of", "planned by", "sold by", "invented by", "pieced together by"],
    "origin":["imagine #WORK# &#ZEILE1# &#ZEILE2# &#ZEILE3#"],
    "ADJ3":["sloppy", "sad", "weeping", "soaked", "half baked", "muddy", "mouldy", "smoking", "smiling"],
    "VERB3":["engraved in", "printed on", "painted on", "performed by", "chanted by", "played by"],
    "ADJ2":["marvelous", "colonial", "electronic", "astronomic", "unhealthy", "bloated", "european", "hard boiled", "blown", "wind swept", "deafening", "restricted", "censored", "ergonomic"],
    "ZEILE2":["#VERB2# #ADJ2# #NOUN2#"],
    "ZEILE3":["and #VERB3# #ADJ3# #NOUN3#"],
    "VERB2":["collected by", "sought by", "modified by", "enlarged by", "emancipated from", "clattering with", "rattling in", "bragging about", "humming in", "squeaking from", "shining through"],
    "ZEILE1":["#VERB1# #ADJ1# #NOUN1#"],
    "ADJ1":["lazy", "shallow", "ringing", "raging", "angry", "rusty", "derelict", "ancient", "furious", "silver", "burning", "exploding", "singing", "freezing", "mad", "californian", "humming", "chanting", "shouting", "silent"],
    "NOUN1":["mice", "thoughts", "ponds", "alarm clocks", "TVs", "blockchains", "artificial intelligences", "telegrams", "bicycles", "smart watches", "stock markets", "oil barrels", "caterpillars", "nyan cats", "collectives"]
}

const grammarDE = {
    "origin":["stell dir #WORK# vor&#ZEILE1# &#ZEILE2# &#ZEILE3#"],
    "WORK":["ein kunstwerk", "ein gedicht", "ein lied", "einen text", "ein theaterstück", "ein generatives kusntwerk", "ein gemälde", "ein symphonie", "einen gedanken", "einen luftzug", "eine keramik", "ein haiku", "eine skulptur", "eine verschlüsselte datei", "einen telefonanruf", "einen spaziergang im wald"],

    "ZEILE1":["#VERB1# #ADJ1# #NOUN1#"],
    "ZEILE2":["#VERB2# #ADJ2# #NOUN2#"],
    "ZEILE3":["und #VERB3# #ADJ3# #NOUN3#"],

    "VERB2":["gesammelt von", "begehrt von", "verändert von", "vergrössert mit", "entfernt von", "schlotternd mit", "rasselnd in", "summend in", "quietschend von", "rasend von"],
    "ADJ2":["wunderbaren", "kolonialen", "elektronischen", "astronomischen", "ungesunden", "aufgeblasenen", "europäischen", "hartgekochte", "zerbrochenen", "winddurchfegten", "dröhnenden", "verbotenen", "zensurierten", "ergonomischen"],
    "NOUN2":["winden", "regenschauern", "sonnenstrahlen", "ödländern", "verschwörungen", "asteroiden", "arterien", "kanälen", "strassen", "stromleitungen", "geiern"],

    "VERB3":["eingraviert in", "gedruckt auf", "gemalt auf", "aufgeführt von", "gesungen von", "gespielt von"],
    "ADJ3":["schlampigen", "traurigen", "weinenden", "triefenden", "halbgebackenen", "schlammigen", "schimmligen", "rauchenden", "lächelnden"],
    "NOUN3":["papierem", "steinen", "milchflaschen", "wasserkrügen", "gasen", "fellen", "gesichtern", "chören", "musikerinnen"],

    "VERB1":["bestehend aus", "geschrieben von", "komponiert von", "gemacht aus", "geplant von", "verkauft von", "erfunden von", "zusammengestückelt aus"],
    "ADJ1":["faulen", "seichten", "läutenden", "wütenden", "ärgerlichen", "verrosteten", "verlassenen", "alten", "schnaubenden", "silbernen", "brennenden", "explodierenden", "singenden", "frierenden", "verrückten", "kalifornischen", "summenden", "singenden", "rufenden", "leisen"],
    "NOUN1":["mäusen", "gedanken", "weihern", "weckern", "fernsehgeräten", "blockchains", "künstlichen intelligenzen", "telegrammen", "fahrrädern", "smartwatches", "aktienmärkten", "ölfässern", "raupen", "nyan cats", "kollektiven"]
}

let strings = new LocalizedStrings({
    en:{
        title:"imagine",
        description:"imaginary artworks created by a generative grammar."
    },
    de: {
        title:"stell dir vor",
        description:"imaginäre kunstwerke werden von einer generative grammatik erzeugt."
    }
});

class Imagine extends React.Component {
    constructor(props) {
        super(props)

        this.state = {verses: []}
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
        if (this.state.verses.length === 0) {
            this.generate()
        }
    }

    componentWillReceiveProps(props) {
        const { language } = this.props;

        if (props.language !== language) {
            strings.setLanguage(props.language)

            this.generate()
        }
    }

    generate() {
        var grammarLang = strings.getLanguage() === "en" ? grammarEN : grammarDE;
        var grammar = tracery.createGrammar(grammarLang);

        var verse = grammar.expand("#origin#").finishedText

        this.setState({verses: verse.split("&")})
    }

    render() {
        strings.setLanguage(this.context.language)
        return <div className="poemDisplay">
            {this.state.verses.map(function(verse, index){
                return <p key={index}>{verse}</p>;
              })}
        </div>
    }
}
Imagine.contextType = LanguageContext

export default Imagine
